<template>
  <div id="app">
    <Header />

    <main class="app-content">
      <router-view />
    </main>

    <CookieDisclaimer />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/base/Header.vue';
import Footer from '@/components/base/Footer.vue';
import CookieDisclaimer from '@/components/CookieDisclaimer.vue';

export default {
  components: {
    Header,
    Footer,
    CookieDisclaimer,
  },
};
</script>

<style scoped lang="scss">
#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1 0 auto;
}
</style>
